import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { isEmbellishmentChangeLocationConfirmationPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { changeEmbellishmentMethodWithMaxPrintColorsValidation } from '../../../redux/product/product.actions';
import { EmbellishmentChangeLocationConfirmationPopup as EmbellishmentChangeLocationConfirmationPopupComponent } from './embellishment-change-location-confirmation-popup';
const paramsSelector = createSelector(popupParamsSelector, params => params);
const mapStateToProps = createStructuredSelector({
  open: isEmbellishmentChangeLocationConfirmationPopupShownSelector,
  params: paramsSelector
});
const mapDispatchToProps = dispatch => ({
  onConfirm: (methodId, newProdTimeIndex) => {
    dispatch(hidePopup());
    dispatch(changeEmbellishmentMethodWithMaxPrintColorsValidation(methodId, newProdTimeIndex));
  },
  onCancel: () => {
    dispatch(hidePopup());
  }
});
export const EmbellishmentChangeLocationConfirmationPopup = connect(mapStateToProps, mapDispatchToProps)(EmbellishmentChangeLocationConfirmationPopupComponent);